import React, { useEffect, useRef, useState } from 'react'
import ReactDOM from 'react-dom'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { useSelector } from 'react-redux'
import { paypalDoExpressCheckout, paypalOrderSetExpressCheckout, billingPlaceOrder, billingCheckout } from '../../../../../api'
import { BlackMask } from '../../../../components/mask'
import ErrorWrapper from '../../../../error-wrapper'

export const Paypaling = props => {
    useStyles(classes)
    const { hiddeMask } = props;
    return <>
        {
            !hiddeMask && <BlackMask />
        }
        
        <div className={classes.PaypalLoading}/>
        <div className={classes.PaypalBack}/>
    </>
}

export const  PaypalButton = props => {

    const { layout, alloweds, onError, className, inputOrder, shoudBilling, domId, label, redirectType, clickHandle, isFastPayment, check } = props
    const [paypaling, setPaypaling] = useState(false)
    const global = useSelector(state => state.global)
    const result = useRef(null)

    useEffect(() => {
        if (window.paypal) {
            // Render the PayPal button into #paypal-button-container
            window.paypal.Buttons({

                style: {
                    layout: layout || 'horizontal',
                    tagline: false,
                    height: 40,
                    menuPlacement: 'above',
                    label: label || 'paypal'
                },
                funding: {
                    allowed: alloweds
                },
                enableStandardCardFields: true,
                // Call your server to set up the transaction
                createOrder:async () => {
                    setPaypaling(true)
                    let response
                    if(inputOrder){
                        response = {
                            result: inputOrder,
                            code: 200
                        }
                    }else{
                        if(shoudBilling){
                            await billingCheckout()
                        }
                        response = await billingPlaceOrder(isFastPayment)
                    }
                    if(response?.code === 200 && response?.result){
                        const order = response?.result
                        return paypalOrderSetExpressCheckout({ orderId: order?.id, redirectType }).then(data => {
                            if(data.code === 200){
                                result.current = data.result
                                const { transactionId, orderId, success, isFree, method, tokenSuccess } = data.result
                                if (success && transactionId && method === 'DoReferenceTransaction' && tokenSuccess || isFree && transactionId) {
                                    window.location.href = `/order-confirm/${transactionId}`
                                    throw new Error('free')
                                }
                                return data.result.TOKEN
                            }else{
                                throw new Error(data.result || 'Network Error')
                            }
                        }).catch(data => {
                            setPaypaling(false)
                            console.log(data)
                        })
                    }else{
                        setPaypaling(false)
                        throw new Error(response?.result || 'Network Error')
                    }
                },

                // Call your server to finalize the transaction
                onApprove: (data, actions) => {
                    //doExpress
                    const DoExressPromise = paypalDoExpressCheckout({ token: data.orderID, PayerID: data.payerID })
                    DoExressPromise.then(data => {
                        const response = data.result
                        const {transactionId, success, longMessage, shortMessage} = response
                        if(success){
                            window.location.href = `/order-confirm/${transactionId}`
                        }else{
                            setPaypaling(false)
                            onError({
                                message:longMessage || shortMessage || 'Network error.',
                                type: global?.user?.id? 'go_unpaid': undefined,
                                orderId: result.current?.orderId,
                            })

                        }
                    })
                },
                onError: function (err) {
                    setPaypaling(false)
                    if (err) {
                        const msg = err.stack
                        if (msg.indexOf('free') >= 0) {
                            console.log('free order')
                        } else {
                            onError({
                                message: msg.substring(0, msg.indexOf('\n'))
                            })
                        }
                    }
                },
                onCancel: () => {
                    setPaypaling(false)
                    // if (global?.user?.id && result.current && result.current.orderId) {
                    //     window.location.href = `/checkout/${result.current.orderId}`
                    // }
                },
                onClick: function () {
                    try {
                        clickHandle?.()
                        if(check){
                            if(!check()){
                                return false
                            }
                        }
                    } catch (error) {
                        
                    }
                },
                onInit: function (data, actions) {
                }
            }).render(`#${domId || 'paypal-button-container'}`)
        }
    }, [])

    return <>
        <div style={{width: '100%'}} className={className} id={domId || 'paypal-button-container'}></div>
        {
           paypaling && ReactDOM.createPortal(<Paypaling />, document.getElementById('root'))
        }
    </>
}

export default props => <ErrorWrapper>
    <PaypalButton {...props}/>
</ErrorWrapper>